import React, { useEffect, useState } from 'react'
import { useIntent } from '../../../../../hooks/payment-methods/IntentHook'
import { ProgressionStatus } from '../../../common/ActivityProgression'
import ActivityProgression from '../../../common/ActivityProgression'

export function Intent({
  success,
  failure,
  charityId,
  contractId,
}: {
  success: (clientSecret: string) => void
  failure: (e: unknown) => void
  charityId: string
  contractId: string
}): JSX.Element {
  const { intent } = useIntent()
  const [state, setState] = useState<'idle' | 'intent' | 'success'>('idle')
  useEffect(() => {
    setState('intent')
    void intent(charityId, contractId, true)
      .then(clientSecret => {
        setState('success')
        success(clientSecret)
      })
      .catch(failure)
  }, [])
  return (
    <div>
      <ActivityProgression status={getIntentProgressionStatus(state)} />
    </div>
  )
}

function getIntentProgressionStatus(state: 'idle' | 'intent' | 'success'): ProgressionStatus {
  switch (state) {
    case 'idle':
      return { status: 'idle' }
    case 'intent':
      return { status: 'pending' }
    case 'success':
      return { status: 'success' }
  }
}
